<div [ngSwitch]="item.type">
  <div *ngSwitchCase="sidenavItemsTypes.Item">
    <div *ngIf="item.isRouteString(); then routeNavItem; else functionNavItem"></div>
  </div>
  <mat-divider *ngSwitchCase="sidenavItemsTypes.Separator"></mat-divider>
  <ng-container *ngSwitchCase="sidenavItemsTypes.Link">
    <a class="sidenav-anchor" mat-list-item mat-ripple [href]="item.link" target="_blank" rel="noopener">
      <mat-icon *ngIf="item.icon.length > 0; else svgIcon">{{ item.icon }}</mat-icon>
      <ng-template #svgIcon>
        <mat-icon [svgIcon]="item.svgIcon"></mat-icon>
      </ng-template>
      <span class="sidenav-item-name fade-in-on-icon-sidenav">{{ item.name }}</span>
    </a>
  </ng-container>
</div>

<ng-template #functionNavItem>
  <a class="sidenav-anchor" [ngClass]="item.customClass" *ngIf="!item.hasSubItems()" mat-list-item mat-ripple
     (click)="item.route()">
    <mat-icon *ngIf="item.icon.length > 0; else svgIcon">{{ item.icon }}</mat-icon>
    <ng-template #svgIcon>
      <mat-icon [svgIcon]="item.svgIcon"></mat-icon>
    </ng-template>
    <span class="sidenav-item-name fade-in-on-icon-sidenav">{{ item.name }}</span>
    <span><!-- fill space --></span>
    <span class="badge fade-in-on-icon-sidenav" *ngIf="item.badge"
          [style.background-color]="item.badgeColor">{{ item.badge }}</span>
  </a>
</ng-template>

<ng-template #routeNavItem>
  <a
    class="sidenav-anchor"
    [ngClass]="item.customClass"
    *ngIf="!item.hasSubItems()"
    mat-list-item
    mat-ripple
    [routerLink]="[item.route]"
    routerLinkActive="active"
  >
    <mat-icon *ngIf="item.icon.length > 0; else svgIcon">{{ item.icon }}</mat-icon>
    <ng-template #svgIcon>
      <mat-icon [class]="item.svgIcon" [svgIcon]="item.svgIcon"></mat-icon>
    </ng-template>
    <span class="sidenav-item-name fade-in-on-icon-sidenav">{{ item.name }}</span>
    <span><!-- fill space --></span>
    <span class="badge fade-in-on-icon-sidenav" *ngIf="item.badge"
          [style.background-color]="item.badgeColor">{{ item.badge }}</span>
  </a>
</ng-template>

<a class="sidenav-anchor" *ngIf="item.hasSubItems()" mat-list-item mat-ripple (click)="toggleDropdown()"
   [ngClass]="item.customClass">
  <mat-icon>{{ item.icon }}</mat-icon>
  <span class="sidenav-item-name fade-in-on-icon-sidenav">{{ item.name }}</span>
  <span><!-- fill space --></span>
  <span class="badge fade-in-on-icon-sidenav" *ngIf="item.badge" [style.background-color]="item.badgeColor"
        style="margin-right: 12px">{{
    item.badge
    }}</span>
  <mat-icon *ngIf="item.hasSubItems()" class="sidenav-item-dropdown-indicator rotate fade-in-on-icon-sidenav">
    expand_more
  </mat-icon>
</a>

<mat-nav-list class="sidenav-list sidenav-list-nested" yout="column" [style.height]="getSubItemsHeight()">
  <mee-sidenav-item *ngFor="let subItem of item.subItems" [item]="subItem"></mee-sidenav-item>
</mat-nav-list>
